
/* Sugar Rush — Interactive JS */
(function() {
  'use strict';

  // ── Sticky header scroll effect ──────────────────────────
  const header = document.querySelector('.site-header, header');
  if (header) {
    window.addEventListener('scroll', function() {
      if (window.scrollY > 50) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    }, { passive: true });
  }

  // ── Scroll-triggered animations ──────────────────────────
  const animEls = document.querySelectorAll(
    '.product-card, .category-card, .bundle-card, .section-heading, .section-subheading'
  );
  animEls.forEach(el => el.classList.add('animate-on-scroll'));

  const observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

  animEls.forEach(el => observer.observe(el));

  // ── Button ripple effect ──────────────────────────────────
  document.addEventListener('click', function(e) {
    const btn = e.target.closest('button, .btn, [type="submit"]');
    if (!btn) return;
    // Skip TikTok carousel elements
    if (btn.closest('#srtk') || btn.closest('.srtk') || btn.closest('[id^="srtk"]')) return;
    const ripple = document.createElement('span');
    ripple.classList.add('btn-ripple');
    const rect = btn.getBoundingClientRect();
    const size = Math.max(rect.width, rect.height);
    ripple.style.width = ripple.style.height = size + 'px';
    ripple.style.left = (e.clientX - rect.left - size / 2) + 'px';
    ripple.style.top  = (e.clientY - rect.top  - size / 2) + 'px';
    btn.style.position = 'relative';
    btn.style.overflow = 'hidden';
    btn.appendChild(ripple);
    ripple.addEventListener('animationend', () => ripple.remove());
  });

  // ── Add hover overlay to product cards ───────────────────
  document.querySelectorAll('.product-card').forEach(function(card) {
    const imgWrap = card.querySelector('.product-card__image-wrap');
    if (!imgWrap) return;
    if (imgWrap.querySelector('.product-card__hover-overlay')) return;

    // Get the form/button inside the card
    const form = card.querySelector('form');
    const addBtn = card.querySelector('[name="add"], .product-card__add-btn, button[type="submit"]');

    const overlay = document.createElement('div');
    overlay.className = 'product-card__hover-overlay';

    const quickBtn = document.createElement('button');
    quickBtn.className = 'product-card__quick-add';
    quickBtn.textContent = '🛒 ADD TO CART';
    quickBtn.type = 'button';

    quickBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      if (form) {
        // Submit the form
        const submitBtn = form.querySelector('[type="submit"], button');
        if (submitBtn) submitBtn.click();
      } else if (addBtn) {
        addBtn.click();
      }
      // Visual feedback
      quickBtn.textContent = '✓ ADDED!';
      quickBtn.style.background = 'linear-gradient(135deg, #22c55e, #16a34a)';
      setTimeout(function() {
        quickBtn.textContent = '🛒 ADD TO CART';
        quickBtn.style.background = '';
      }, 1500);
    });

    overlay.appendChild(quickBtn);
    imgWrap.appendChild(overlay);
  });

  // ── Update review count on product detail page only ────────
  // Only show 127 reviews on individual product pages, not on cards
  var reviewCountEl = document.querySelector('.product-detail__stars .review-count');
  if (reviewCountEl) {
    reviewCountEl.textContent = '127 reviews';
  }
  // Style the stars on product detail page
  document.querySelectorAll('.product-detail__stars .stars').forEach(function(el) {
    el.innerHTML = '<span class="star">★</span><span class="star">★</span><span class="star">★</span><span class="star">★</span><span class="star">★</span>';
  });

  // ── Candy confetti on hero ────────────────────────────────
  const hero = document.querySelector('.hero-banner, .hero-section, [class*="hero"]');
  if (hero) {
    const candies = ['🍬', '🍭', '🍡', '🍫', '🍩', '⭐', '✨'];
    for (let i = 0; i < 12; i++) {
      const candy = document.createElement('div');
      candy.className = 'candy-confetti';
      candy.textContent = candies[Math.floor(Math.random() * candies.length)];
      candy.style.left = Math.random() * 100 + '%';
      candy.style.animationDuration = (8 + Math.random() * 10) + 's';
      candy.style.animationDelay = (Math.random() * 8) + 's';
      candy.style.fontSize = (16 + Math.random() * 14) + 'px';
      hero.appendChild(candy);
    }
  }

  // ── Social proof: "X people viewing this" on product pages ─
  const productTitle = document.querySelector('.product-title, .product__title, h1.title');
  if (productTitle) {
    const viewers = Math.floor(Math.random() * 8) + 4;
    const ticker = document.createElement('div');
    ticker.className = 'social-proof-ticker';
    ticker.innerHTML = '<span class="live-dot"></span> ' + viewers + ' people viewing this right now';
    productTitle.parentNode.insertBefore(ticker, productTitle);
  }

  // ── Animate numbers counting up ──────────────────────────
  function animateCount(el, target, duration) {
    let start = 0;
    const step = target / (duration / 16);
    const timer = setInterval(function() {
      start += step;
      if (start >= target) {
        el.textContent = target;
        clearInterval(timer);
      } else {
        el.textContent = Math.floor(start);
      }
    }, 16);
  }

  // Review count animation — product detail page only (handled above)

})();
